<script setup lang="ts">
import { KsIcon } from '@aschehoug/kloss'
import { StudentProgress } from '~/models/Activity'
import { computed } from 'vue'

const props = defineProps<{
  progress: StudentProgress
}>()

const shortenedStudentName = computed(() =>
  `${props.progress.user.firstName} ${props.progress.user.lastName.charAt(0)}`)

</script>

<template>
  <p
    class="col-span-6 overflow-x-hidden text-ellipsis whitespace-nowrap font-medium xs:col-span-4"
    v-text="shortenedStudentName"
  />
  <div class="col-span-2 flex items-center gap-2 xs:col-span-4">
    <KsIcon
      :id="progress.progress === 100 ? 'check-circle' : 'xmark-circle'"
      class="text-lg"
      :class="progress.progress === 100 ? 'text-green-40' : 'text-redpink-40'"
    />
    <p
      class="hidden text-sm xs:block"
      v-text="progress.status"
    />
  </div>
  <p
    v-if="progress.lastInteraction"
    class="col-span-4 text-sm"
    v-text="progress.lastInteraction"
  />
</template>
